import moment from "moment";

const HelperService = {
  formatDate(date: string) {
    if (date) {
      return moment(date).format("DD-MM-YYYY");
    }
  },
  truncate(str: string, size: number) {
    return str.length > size ? str?.substring(0, size) + "..." : str;
  },
  removeDecimal(value: any) {
    return value ? Math.floor(value) : 0;
  },
  validateEmail(email: any) {
    const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  },
  isValidPassword(password: string) {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (passwordRegex.test(password)) return true;
    else return false;
  },
  removeUnderScore(str: any) {
    if (!str) return "-";
    if ((str !== "" || str !== undefined) && str.includes("_")) {
      return this.titleCase(str.replace(/_/g, " "));
    } else {
      return this.titleCase(str);
    }
  },
  removeDialCodeFromMobile(mobileNumber: any, dialCode: any) {
    if (
      typeof mobileNumber === "string" &&
      typeof dialCode === "string" &&
      dialCode.length > 0
    ) {
      if (mobileNumber.startsWith(dialCode)) {
        return mobileNumber.slice(dialCode.length);
      }
    }
    return mobileNumber;
  },
  titleCase(str: any) {
    if (str !== "") {
      return str
        .toLowerCase()
        .split(" ")
        .map((word: any) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    } else {
      return str;
    }
  },
  getFormattedDateWithTime(dt: any) {
    if (dt) {
      return moment(dt).format("DD-MM-YYYY hh:mm A");
    }
  },
  getDivHeight(id: any) {
    let div = document.getElementById(id);
    if (div) {
      return div.offsetHeight;
    }
  },
  toProperCase(str: string) {
    if (!str) {
      return "";
    }
    const pattern = /_/gi;
    const replacement = " ";
    const result = str.replaceAll(pattern, replacement);

    return result.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  decideBadgeClass(status: string) {
    if (status === "ACTIVE") return "badge badge-green";
    else if (status === "INACTIVE") return "badge badge-danger";
    else if (status === "In_Active") return "badge badge-danger";
    else if (status === "PUBLISHED") return "badge badge-green";
    else if (status === "Published") return "badge badge-green";
    else if (status === "UNPUBLISHED") return "badge badge-danger";
    else if (status === "APPROVED") return "success";
    else if (status === "REJECTED") return "danger";
    else if (status === "PENDING") return "warning";
  },
  formatDevice(ua: string) {
    if (!ua) return "-";

    if (ua.includes("Chrome")) return "Chrome Browser";
    if (ua.includes("Firefox")) return "Firefox";
    if (ua.includes("Safari")) return "Safari";
    if (ua.includes("Windows")) return "Windows Device";
    if (ua.includes("Android")) return "Android Device";
    if (ua.includes("iPhone")) return "iPhone";

    return "Unknown Device";
  },
  getFormatedDateByDMYTime(d: any) {
    return d && d !== "0000-00-00"
      ? moment(d).format("DD-MMM-YYYY hh:mm A")
      : "NA";
  },
  formatAmountIntl(amount1: string | number = 0): string {
    if (amount1 === null || amount1 === undefined) return "";

    const amount = typeof amount1 === "number" ? amount1 : parseFloat(amount1);
    if (isNaN(amount)) return "";

    if (amount >= 1_000_000_000_000) {
      return `${(amount / 1_000_000_000_000).toFixed(2)} T`;
    } else if (amount >= 1_000_000_000) {
      return `${(amount / 1_000_000_000).toFixed(2)} B`;
    } else if (amount >= 1_000_000) {
      return `${(amount / 1_000_000).toFixed(2)} M`;
    } else if (amount >= 1_000) {
      return `${(amount / 1_000).toFixed(2)} K`;
    } else {
      return amount.toFixed(2);
    }
  },
};

export default HelperService;
